<script>
  import Modal from './Modal.svelte';
  import Grid from './Grid.svelte';
  import Button from './Button.svelte';
  import { getQueryColumns, getTotalMarketAvailability } from '../data.js';
  import { numberWithDigitGrouping } from '../utils.js';

  let parts;
  let columns;
  let totalMarketAvailability = null;
  let visible;

  export async function show(partsList) {
    console.log({partsList});
    columns = getQueryColumns();
    let totalAvailability = getTotalMarketAvailability(partsList);
    totalMarketAvailability = `${numberWithDigitGrouping(totalAvailability)}`;
    parts = partsList;
    visible = true;
  }
</script>

<Modal {visible}>
  <div class="container">
    <Grid data={parts} {columns} banded sortable />
    <div class="footer">
      <span>TOTAL STOCK: {totalMarketAvailability || "pending"}</span>
      <div class="button"><Button on:click={() => visible = false}>Close</Button></div>
    </div>
  </div>
</Modal>

<style>
  .container {
    display: grid;
    grid-template-rows: auto min-content;
    width: 100%;
    height: 90vh;
    gap: 5px;
  }

  .footer {
    display: grid;
    grid-template-columns: auto min-content;
    align-items: center;
  }
</style>